// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__26BCk","modalFooterButton":"ModalNotes_modalFooterButton__1XOTL"};